<!-- 由 suu 创建于 2021-08-26 星期四 -->
<template>
  <div class="InfoScanCode">
    <!-- 上方信息 -->
    <div class="sc-top">
      <div class="top-left">
        <div class="l-day">{{ info.day.replace(/-/g, '.') }}</div>
        <div class="l-time">
          {{ info.info.split(' ')[2]
          }}<span>{{
            info.is_course_test ? '规划课' : info.info.split(' ')[3]
          }}</span>
        </div>
        <div class="l-count" v-if="countDown">{{ countDown }}</div>
        <div class="l-shop text-overflow">
          <i class="iconfont iconlocation"></i>
          {{ info.shopname || info.shop_name
          }}<span v-if="localStatus">（{{ localStatus }}）</span>
        </div>
      </div>
      <div class="top-right">
        <img
          class="r-img"
          :src="
            info.coachImg ||
            'https://cdnvue.gymcity.com.cn/uploads/pub-logo-zfx'
          "
          alt=""
        />
        <div class="r-name">{{ info.coachName || info.coachname }}</div>
      </div>
    </div>
    <!-- 扫码信息 -->
    <div class="sc-code" v-if="status == 1">
      <div class="c-title">请给教练扫码，开启课程</div>
      <div class="c-shop">{{ info.shopname || info.shop_name }}</div>
      <div class="c-wifi">
        <i class="iconfont iconwifi"></i>
        {{ networkStatus }}
      </div>
      <img class="c-qrcode" src="@/assets/imgs/scan-qrcode.png" alt="" />
      <!-- <div class="c-tips">{{tipStatus}}</div> -->
      <div class="c-btn user-btn" @click="clickRefresh">刷新</div>
    </div>
    <!-- 扫码成功 -->
  </div>
</template>

<script>
import DATE from '../../../common/date.js'
export default {
  name: 'InfoScanCode',

  components: {},

  props: {
    info: {}
  },

  data() {
    return {
      status: 0, // 进入时0，当前状态: 1-等待扫码，2-扫码成功，3-没有开始，4-迟到，5-没有课程
      getIP: '', // 当前公网ip
      networkStatus: '无WIFI', // WiFi 状态
      localStatus: '', // 离门店距离状态
      Localtimer: null, // 定位 wifi状态 重复获取 定时器 成功获取或6秒后清除循环
      Scantimer: null, // 轮循获取扫码状态
      tipStatus: '', // 定位 wifi 指导提示文案
      countDown: '', // 倒计时读秒
      timer: null, // 倒计时定时器
      classInfo: {
        // 扫码成功的课程信息
        region_id: '',
        rate: '',
        allDay: '',
        month: '',
        markDay: '',
        target: '',
        badge: '',
        monthClass: '',
        allClass: '',
        tranPlan: '',
        tranOutline: '',
        img: '',
        name: '',
        training_total: '',
        training_type: 'B', // 健萌圈图片样式类型 A B C 目前只保留B
        // 健萌圈图片
        training_data: [],
        coachImg: '',
        coachName: '',
        tag: '',
        shopName: '',
        planTarget: '',
        plan_cal_num: 1,
        user_gender: 'F',
        class_coach_shop_address: ''
      }
    }
  },

  computed: {},

  watch: {},

  created() {
    // 倒计时
    this._getCountDown()
    /**
     * 进入时，当前状态status:
     * 1-等待扫码
     * 2-扫码成功4
     * 3-没有开始
     * 4-迟到
     * 5-没有课程
     */
    this.$http.get2('index/getip', { noToken: 1 }).then((res) => {
      this.getIP = res.data
      this.getGeolocation() // 获取网络状态
      this.getGPS() // 获取定位
      this.getStatus()
    })
  },

  mounted() {},

  destroyed() {},

  beforeDestroy() {
    clearInterval(this.timer)
    clearInterval(this.Localtimer)
    clearInterval(this.Scantimer)
  },

  methods: {
    // 扫码成功 配置数据
    setSuccess(data) {
      this.classInfo = {
        region_id: data.region_id,
        uid: data.uid,
        rate: data.rate,
        allDay: data.diff_month,
        month: data.month,
        markDay: data.day_str,
        target: data.target,
        badge: data.medal_num,
        monthClass: data.month_num,
        allClass: data.all_num,
        tranPlan: data.p_url,
        tranOutline: data.o_url,
        img: data.image
          ? data.image.replace(
              'http://thirdwx.qlogo.cn',
              location.origin + '/wechat_image'
            )
          : '',
        name: data.truename,
        shopName: data.class_coach_shop,
        tag: data.class_coach_evaluate,
        coachImg: data.class_coach_image
          ? data.class_coach_image
              .replace(
                'wegymer-data.oss-cn-beijing.aliyuncs.com',
                'vue.gymcity.com.cn/body_image'
              )
          : '',
        coachName: data.class_coach_name,
        training_total: data.training_total,
        training_type: data.training_type,
        training_data: data.training_data,
        planTarget: data.plan_target || '',
        plan_cal_num: data.plan_cal_num,
        user_gender: data.user_gender,
        class_coach_shop_address: data.class_coach_shop_address
      }
      this.showSuccessPop = true
      // this.showMedal = true
      setTimeout(() => {
        this.showSuccessPop = false
      }, 3000)
      this.$nextTick(() => {
        let canvas = document.getElementById('qrCode-canvas')
        QRCode.toCanvas(canvas, this.qrcodeUrl, (error) => {
          if (error) {
            console.log(error)
          } else {
          }
        })
      })
      // this.getArticleList()
    },
    // 检查是否扫码成功
    // order_type 2 用于记录来源APP扫码
    checkScan() {
      this.$http.post2('index/scan_res', { order_type: 2 }).then((res) => {
        if (res.data.status === 204 || res.data.status === 302) {
          this.status = 4
          clearInterval(this.Scantimer)
        } else if (res.data.status === 200) {
          this.status = 2
          clearInterval(this.Scantimer)
          this.setSuccess(res.data.data)
          // 燃脂挑战期间 扫码成功回调
          this['$http'].get(
            'member/activity.ReduceFatChallenge/?a=experience_join',
            {},
            true
          )
        }
      })
    },
    // 获取当前状态
    getStatus() {
      // 获取进入页面时的状态
      this.$http
        .post2('index/order_res', { ip: this.getIP, order_type: 2 })
        .then((res) => {
          console.log(res)
          const Data = res.data
          const status = res.data.status
          // 进入时，当前状态: 1-等待扫码，2-扫码成功，3-没有开始，4-迟到，5-没有课程
          switch (status) {
            case 1005:
              this.status = 5
              break
            case 1001:
              this.status = 5
              break
            case 302:
              this.status = 4
              break
            case 301:
              this.status = 3
              if (Data.data.p_url) {
                const pid = Data.data.p_url.split('&')[0].split('pid=')[1]
                this.$emit('getPid', pid)
              }
              break
            case 201:
              // this.scanBgImg = Data.data.succ_img;
              // 已经扫过码
              this.status = 2
              this.setSuccess(Data.data)
              break
            case 200:
              // 等待扫码
              this.status = 1
              this.$nextTick(() => {
                // 等待扫码状态时 2秒一次获取ip 和 定位状态 获取到或满6秒结束循环
                this.Localtimer = setInterval(() => {
                  this.getGeolocation()
                  this.getGPS()
                }, 2000)
                setTimeout(() => {
                  clearInterval(this.Localtimer)
                  if (this.networkStatus === '获取中...') {
                    this.networkStatus = '无WIFI'
                  }
                  if (this.localStatus === '定位中...') {
                    this.localStatus = '获取定位失败'
                    if (this.networkStatus === '无WIFI') {
                      this.tipStatus = '*请打开APP定位权限或连接场馆WIFI'
                    } else {
                      this.tipStatus = '*获取定位失败，请打开APP定位权限'
                    }
                  }
                }, 6000)
                // 2秒一次循环获取扫码状态
                this.Scantimer = setInterval(() => {
                  this.checkScan()
                }, 2000)
              })
              if (Data.data.p_url) {
                const pid = Data.data.p_url.split('&')[0].split('pid=')[1]
                this.$emit('getPid', pid)
              }
              this.classInfo.region_id = Data.data.region_id || ''
              break
            default:
              this.$dialog.alert({ message: '网络错误，请联系客服！' })
              break
          }
        })
    },
    // 获取当前网络状态
    getGeolocation() {
      const connection = navigator.connection ||
        navigator.mozConnection ||
        navigator.webkitConnection || { type: 'unknown' }
      if (connection.type === 'wifi') {
        this.networkStatus = '已连接'
      } else {
        this.networkStatus = '无WIFI'
      }
    },
    // 获得定位信息
    getGPS() {
      if (this.$store.state.location) {
        const lat = this.$store.state.location.lat
        const lng = this.$store.state.location.lng
        this.getGPSStatus(lat, lng)
      } else if (this.$http._getQuery('lat')) {
        const { lat, lng } = this.$http.gcj_decrypt(
          this.$http._getQuery('lat'),
          this.$http._getQuery('lng')
        )
        this.$store.commit('saveLocation', {
          lat,
          lng
        })
        this.getGPSStatus(lat, lng)
      } else {
        this.$betterwe
          .requestLocation()
          .then((res) => {
            if (res.errorCode != -1) {
              // 坐标转换
              const { lat, lng } = this.$http.gcj_decrypt(
                res.latitude,
                res.longitude
              )
              this.$store.commit('saveLocation', {
                lat,
                lng
              })
            } else {
              // Toast('获取位置失败，请检查APP定位设置')
            }
          })
          .catch((e) => {
            // Toast('获取位置失败，请检查APP定位设置')
            console.log(e)
          })
          .finally(() => {
            let lat = ''
            let lng = ''
            if (this.$store.state.location) {
              lat = this.$store.state.location.lat
              lng = this.$store.state.location.lng
              this.getGPSStatus(lat, lng)
            } else {
              this.localStatus = '获取定位失败'
              if (this.networkStatus === '无WIFI') {
                this.tipStatus = '*请打开APP定位权限或连接场馆WIFI'
              } else {
                this.tipStatus = '*获取定位失败，请打开APP定位权限'
              }
            }
          })

        // 通过腾讯地图获取定位
        // if (qq && new qq.maps.Geolocation()) {
        //   const geolocation = new qq.maps.Geolocation()
        //   geolocation.getLocation(
        //     (position) => {
        //       //定位数据获取成功响应
        //       console.log('====================================')
        //       console.log('定位', position)
        //       console.log('====================================')
        //       const { lat, lng } = this.$http.gcj_decrypt(
        //         position.lat,
        //         position.lng
        //       )
        //       this.getGPSStatus(lat, lng)
        //     },
        //     (error) => {
        //       //定位数据获取失败响应
        //       console.log('====================================')
        //       console.log('定位error', error)
        //       console.log('====================================')
        //       this.localStatus = '获取定位失败'
        //       if (this.networkStatus === '无WIFI') {
        //         this.tipStatus = '*请打开APP定位权限或连接场馆WIFI'
        //       } else {
        //         this.tipStatus = '*获取定位失败，请打开APP定位权限'
        //       }
        //     }
        //   )
        // } else {
        //   this.$toast('您的浏览器不支持使用HTML 5来获取地理位置服务')
        // }
      }
    },
    // 获得定位和门店距离状态
    getGPSStatus(lat, lng) {
      this.$http
        .post2('index/distance', {
          lng,
          lat,
          ip: this.getIP
        })
        .then((res) => {
          // 拿到了返回的门店信息
          if (res.data.status === 200) {
            this.localStatus = '已到场'
            clearInterval(this.Localtimer)
          } else {
            this.localStatus = '未到场'
            if (
              this.networkType === '无WIFI' &&
              this.localStatus === '未到场'
            ) {
              this.tipStatus = '*定位异常，请连接场馆WIFI'
            }
          }
        })
    },
    /**
     * 刷新
     */
    clickRefresh() {
      window.location.reload()
    },
    /**
     * 计算倒计时
     */
    _getCountDown() {
      this.timer = setInterval(() => {
        const starttime = this.info.starttime * 1000
        if (new Date().getTime() >= starttime) {
          this.countDown = ''
          clearInterval(this.timer)
          this.timer = null
          return
        }
        const date = DATE.getDistanceDay('now', starttime, 1)
        this.countDown = `距离上课还有：${date[0] ? date[0] + '天' : ''}${
          Number(date[1]) ? date[1] + '小时' : ''
        }${Number(date[2]) ? date[2] + '分钟' : ''}${
          date[3] ? date[3] + '秒' : ''
        }`
      }, 1000)
    }
  }
}
</script>

<style lang="scss" scoped>
@function vw($px) {
  @return ($px / 375) * 100vw;
}
.InfoScanCode {
  width: 100%;
  box-sizing: border-box;
  padding: 0 5.3vw;
  display: flex;
  flex-direction: column;
  align-items: center;
  .sc-top {
    width: 100%;
    box-sizing: border-box;
    margin-top: 5.6vw;
    display: flex;
    align-items: center;
    justify-content: space-between;
    .top-left {
      color: #fff;
      .l-day {
        font-size: 4vw;
        font-family: DIN;
      }
      .l-time {
        font-size: 8vw;
        font-family: DIN;
        font-weight: 600;
        display: flex;
        align-items: center;
        span {
          margin-left: 2.1vw;
          padding: 0.1vw 2.4vw;
          color: #000;
          font-size: 2.7vw;
          font-weight: 600;
          background-color: #ffffff;
          background-color: #ffffff;
          border-radius: 1.1vw;
        }
      }
      .l-count {
        font-size: 3.5vw;
        margin-top: 0.3vw;
      }
      .l-shop {
        display: flex;
        align-items: center;
        padding: 0.8vw 2.4vw;
        width: 60.5vw;
        height: 6.7vw;
        background-color: rgba(0, 0, 0, 0.2);
        border-radius: 1.1vw;
        font-size: 3.2vw;
        font-weight: 600;
        margin-top: 3.7vw;
        .iconlocation {
          font-weight: 400;
          font-size: 2.7vw;
          margin-right: 2.1vw;
        }
      }
    }
    .top-right {
      display: flex;
      flex-direction: column;
      align-items: center;
      .r-img {
        width: 17.1vw;
        height: 17.1vw;
        background-color: #d8d8d8;
        box-shadow: 0vw 1.3vw 2.7vw 0vw rgba(0, 0, 0, 0.1);
        border-radius: 2.7vw;
      }
      .r-name {
        font-size: 3.7vw;
        color: #ffffff;
        font-weight: 600;
        margin-top: 4vw;
      }
    }
  }
  .sc-code {
    width: 100%;
    box-sizing: border-box;
    padding: 3.7vw;
    padding-bottom: 6vw;
    background-color: #ffffff;
    border-radius: 2.7vw;
    display: flex;
    flex-direction: column;
    align-items: center;
    margin-top: 5.6vw;
    .c-title {
      font-size: 4.8vw;
      font-weight: 600;
      color: #000000;
    }
    .c-shop {
      font-size: 3.5vw;
      color: rgba(0, 0, 0, 0.5);
      margin-top: 1.1vw;
    }
    .c-wifi {
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 3.5vw;
      font-weight: 600;
      margin-top: 4.3vw;
      .iconwifi {
        font-size: 4.8vw;
        color: $weRed;
        margin-right: 2.1vw;
        margin-top: -0.5vw;
      }
    }
    .c-qrcode {
      width: 64vw;
      border: solid 0.3vw #f1f1f1;
      margin-top: 2.1vw;
    }
    .c-btn {
      width: 69.3vw;
      height: 9.6vw;
      background-color: #ffffff;
      border-radius: 1.6vw;
      border: solid 0.3vw #e7e7e7;
      display: grid;
      place-items: center;
      font-size: 3.7vw;
      font-weight: 600;
      color: #000000;
      margin-top: 4.3vw;
    }
  }
}
</style>
